// Parte una lista en trozos de un tamaño máximo, en orden; lo usa el exporte, que Siigo recibe de a 500
// filas por archivo.

/** Los trozos de `filas`, cada uno de a lo sumo `tamano`; una lista vacía no tiene trozos. */
export function trocear<T>(filas: T[], tamano: number): T[][] {
  const trozos: T[][] = [];
  for (let i = 0; i < filas.length; i += tamano) trozos.push(filas.slice(i, i + tamano));
  return trozos;
}
